import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { CacheProofLink } from '@/components/ui/CacheProofLink.tsx';

export const BulkOrderInstructions: React.FunctionComponent = () => {
  const { sgwtHelpCenter, sgwtWebAnalytics } = useSgwtWidgets();

  const openHelp = useCallback(() => {
    sgwtWebAnalytics?.trackEvent('BulkOrder', 'Open help', 'BulkOrder.import');
    sgwtHelpCenter?.topic('BulkOrder.import');
  }, [sgwtHelpCenter, sgwtWebAnalytics]);

  const prefix = 'BulkOrder';
  const values = useMemo(
    () => ({
      help: (
        // oxlint-disable-next-line anchor-is-valid -- This is a link to help center. It is not a navigation link.
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            openHelp();
          }}
        >
          <FormattedMessage id="bulkOrder.import.help" tagName="u" />
        </a>
      ),

      link: (
        <CacheProofLink href={`/samples/${prefix}Example.xlsx`} fileName={`SGME-FX-${prefix}.xlsx`}>
          <FormattedMessage id="bulkOrder.import.link" tagName="u" />
        </CacheProofLink>
      ),
    }),
    [openHelp],
  );

  return (
    <div className="my-4 text-secondary text-right">
      <p>
        <FormattedMessage id="bulkOrder.import.message1" />
      </p>
      <p>
        <FormattedMessage id="bulkOrder.import.message2" values={values} />
      </p>
    </div>
  );
};
